import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="permanent-input"

// This adds a turbo-permanent attribute to the input element when the input is focused.
// This allows the input to persist across page loads, making it useful for search inputs where we want to be able to hit enter and submit the form without losing cursor and focus

export default class extends Controller {
  connect() {
    this.element.addEventListener('focus', this.addPermanentAttribute.bind(this));
    this.element.addEventListener('blur', this.removePermanentAttribute.bind(this));
  }

  disconnect() {
    this.element.removeEventListener('focus', this.addPermanentAttribute.bind(this));
    this.element.removeEventListener('blur', this.removePermanentAttribute.bind(this));
  }

  addPermanentAttribute() {
    this.element.setAttribute('data-turbo-permanent', '');
  }
  removePermanentAttribute() {
    this.element.removeAttribute('data-turbo-permanent');
  }
}
